module.exports = __webpack_public_path__ + "2abee2f883079dc488090adc36cda64a.png";